const myUser = JSON.parse(window.localStorage.getItem("LocalSession") || '{}');
const permisos = myUser?.permisos?.$values;

export const isAllowed = (permisoIds: number | number[]): boolean => {
    if (!permisos) return false;
    const ids = Array.isArray(permisoIds) ? permisoIds : [permisoIds];
    return ids.some(id => permisos.some((p: any) => p.id === id));
};